<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-orange" sprite="devices" />
          Phone Models
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-orange" sprite="devices" />
            Phone Models
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <edit-form
      :editVisible="editVisible"
      :clearFormFields="clearFormFields"
      :editProcessing="editProcessing"
      :selectedPhoneModel="selectedPhoneModel"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
    />

    <create-form
      :createVisible="createVisible"
      :clearFormFields="clearFormFields"
      :createProcessing="createProcessing"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from 'lodash';
import { globalEventBus} from "../../../globalEventBus";
import feathersClient from "../../../feathers/feathers-client";
import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";

export default {
  name: "PhoneModelsTable",
  data() {
    return {
      eventChannel: null,
      createProcessing: false,
      editProcessing: false,
      deleteProcessing: false,
      tableLoading: false,
      tableData: [],
      allModels: [],
      search: "",
      total: 0,
      visibleActionsId: "",
      editVisible: false,
      createVisible: false,
      clearFormFields: false,
      selectedPhoneModel: null,
      tableColumns: [
        {
          field: 'sprite',
          title: '',
          width: 50,
          slots: {
            default: ({row}) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-orange" sprite="devices"/>
                </div>
              ]
            }
          }
        },
        {
          field: 'name',
          minWidth: 150,
          showOverflow: true,
          sortable: true
        },
        {
          field: 'actions',
          title: '',
          minWidth: '150',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={'edit-'+ row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={'delete-'+row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ]
            }
          }
        }
      ]
    };
  },
  components: {
    CreateForm,
    EditForm
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  watch: {
    user() {
      this.findPhoneModels();
      if(!this.eventChannel){
        this.joinSocketChannel();
      }
    },
    search: debounce(function () {
      this.searchModels();
    }, 500)
  },
  methods: {
    ...mapActions("device-models", {
      deletePhoneModels: "remove",
      createPhoneModels: "create",
      patchPhoneModels: "patch"
    }),

    searchModels() {
      if(this.search.length){
        this.tableData = this.allModels.filter(
          data =>
            data.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allModels];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    cellClicked(data){
      if(data.column.property !== 'actions'){
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
    },

    openEditModal(id) {
      this.clearFormFields = false;
      feathersClient
        .service("device-models")
        .get(id)
        .then(res => {
          this.selectedPhoneModel = res;
          this.editVisible = true;
        });
    },

    findPhoneModels(){
      this.tableLoading = true;
      feathersClient.service('device-models').find().then( res => {
        this.tableData = [...res];
        this.allModels = [...res];
        this.total = res.length;
        this.tableLoading = false;
      }).catch( () => {
        this.tableData = [];
        this.tableLoading = false;
      })
    },

    createOperation(createBody) {

      this.$confirm("Create phone model?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          this.createPhoneModels(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.createProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation("create");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editBody) {
      this.$confirm("Edit phone model?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          this.patchPhoneModels([this.selectedPhoneModel.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success"
              });
              this.editProcessing = false;

              this.clearFormFields = true;
              this.cancelOperation("edit");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      this.clearFormFields = true;
      if (type === "create") {
        this.createVisible = false;
      } else if (type === "edit") {
        this.editVisible = false;
      }
    },

    deleteOperation(id) {
      this.$confirm("Delete phone model?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.deleteProcessing = true;

          this.deletePhoneModels(id)
            .then(() => {
              this.deleteProcessing = false;
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },


    joinSocketChannel(){
      const channelService = feathersClient.service('channel-memberships');
      const data = {
        roomType: 'global-admins',
      };
      channelService.create(data).then(res => {this.eventChannel = 'global-admins'});
    },

    removeListeners() {
      const userService = feathersClient.service('device-models');
      userService.removeListener('created');
      userService.removeListener('patched');
      userService.removeListener('removed');
      globalEventBus.$off('appReconnected');
    },
  },

  created(){

    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    //record was edited
    feathersClient.service("device-models").on("patched", data => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allModels.findIndex(
        item => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allModels.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("device-models").on("created", data => {
      this.tableData.push(data);
      this.allModels.push(data);
    });

    //record was deleted
    feathersClient.service("device-models").on("removed", data => {
      const indexToRemove = this.tableData.findIndex(
        item => item.id === data.id
      );
      const indexAllToRemove = this.allModels.findIndex(
        item => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allModels.splice(indexAllToRemove, 1);
      }
    });

  },

  mounted() {
    if (this.user) {
      this.findPhoneModels();
      this.joinSocketChannel();
    }
  },

  beforeDestroy() {
    feathersClient.service('channel-memberships').remove(null, {query: {channelName: this.eventChannel}});
    this.removeListeners();
  }
};
</script>
